import { render, staticRenderFns } from "./ModuleDataTableWindow.vue?vue&type=template&id=61a09686&scoped=true&"
import script from "./ModuleDataTableWindow.vue?vue&type=script&lang=js&"
export * from "./ModuleDataTableWindow.vue?vue&type=script&lang=js&"
import style0 from "./ModuleDataTableWindow.vue?vue&type=style&index=0&id=61a09686&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a09686",
  null
  
)

export default component.exports